<template>
    <component
        :is="icon"
        v-if="icon"
        :size="size"
        :style="iconStyles"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import * as icons from 'lucide-vue-next'

const props = withDefaults(
    defineProps<{
        name?: string
        size?: number | string
    }>(),
    {
        name: '',
        size: 16,
    }
)

// Computed
const icon = computed(() => {
    return icons[props.name] || props.name
})
const sizeValue = computed(() => {
    return Math.max(+props.size, 0)
})
const iconStyles = computed(() => ({
    width: `${sizeValue.value}px`,
    height: `${sizeValue.value}px`,
    // fill: props.color,
    // stroke: props.color.value,
}))

</script>
